<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template
      v-if="userData"
      #button-content
    >
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0 text-capitalize">
          {{ fullName || userData.username }}
        </p>
        <span class="user-status">{{ userData.role }}</span>
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <!-- :src="userData.avatar" -->
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <!-- <b-dropdown-item
      :to="{ name: 'pages-profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profile</span>
    </b-dropdown-item> -->

    <!-- <b-dropdown-divider /> -->

    <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{ $t('Settings') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="handleLogOut"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  // BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import { mapMutations, mapGetters } from 'vuex'
import { avatarText } from '@core/utils/filter'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    // BDropdownDivider,
    BAvatar,
  },
  mixins: [sweetAlert],
  data() {
    return {
      // userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    fullName() {
      return `${this.userData.firstname} ${this.userData.lastname}`
    },
  },
  methods: {
    ...mapMutations({
      setToken: 'auth/setToken',
      setRefreshToken: 'auth/setRefreshToken',
      setCurrentUser: 'auth/setCurrentUser',
      setExpiresIn: 'auth/setExpiresIn',
    }),
    handleLogOut() {
      this.confirm(this.onLogout, { text: this.$t('Are you sure you want to Logout?'), confirmButtonText: this.$t('Yes, Logout'), cancelButtonText: this.$t('No') })
    },
    onLogout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      this.$store.dispatch('auth/logout')
      this.$store.dispatch('tableCache/clearTableCache')
      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
